import React from "react";
import useWhitelabel from "hooks/useWhitelabel";
import wrapperHOC from "@Utils/wrapperHOC";
import PartnerReferHomeSection from "./PartnerReferHomeSection";
import PartnerReferWhitelabelSection from "./PartnerReferWhitelabelSection";

interface PartnerReferSectionProps {
  isDesktop?: boolean;
  data: any;
}

const PartnerReferSection: React.FC<PartnerReferSectionProps> = ({ isDesktop = false, data }) => {
  const { isWhitelabel } = useWhitelabel();

  if (!data?.id) return null;

  return isWhitelabel ? (
    <PartnerReferWhitelabelSection isDesktop={isDesktop} data={data} />
  ) : (
    <PartnerReferHomeSection isDesktop={isDesktop} data={data} />
  );
};

export default wrapperHOC(PartnerReferSection, {
  componentName: "PartnerReferSection-Home",
  showForChina: true,
});
